import { render, staticRenderFns } from "./TestHelperSidebar.vue?vue&type=template&id=51264ea7&"
import script from "./TestHelperSidebar.vue?vue&type=script&lang=js&"
export * from "./TestHelperSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports